export const LogoImage = ({ className = "h-9 w-auto", inverted = false }) => (
  <img
    src="/logo.png"
    alt="BlueSettle — Commercial Energy, Smarter Settled"
    className={`${className} ${inverted ? "brightness-0 invert" : ""}`}
  />
);
